import { useEffect, useRef, useState } from "react"
import axios from 'axios'
import * as Yup from 'yup';
import {useFormik } from 'formik'
import { Modal } from "bootstrap";
import { useToast } from '../../toastHook'
import { errorCss } from '../Utils/formik-util';

export const MatchageConstanteFormComponent = ({ values, handleChange, errors, hasExplainAlert, hasExplain }) => {
    const [personalInfoFinders, setPersonalInfoFinders] = useState([]);
    const [matchageScoreCalculators, setMatchageScoreCalculators] = useState([]);
    const modalWarningRef = useRef();

    useEffect(() => {
        axios.get("/api/MatchageConfigurationforall/finders")
            .then(response => {
                if (response.data) {
                    setPersonalInfoFinders(response.data);
                }
            })
    }, []);

    useEffect(() => {
        axios.get("/api/MatchageConfigurationforall/scorers")
            .then(response => {
                if (response.data) {
                    setMatchageScoreCalculators(response.data);
                }
            })
    }, []);


    if (personalInfoFinders.length === 0 || matchageScoreCalculators.length === 0) {
        return <div>loading ...</div>
    }

    let explain = <></>
    if (hasExplain) {
        explain = <>
            <div className="mb-3">
                <input className="form-check-input me-2" type="checkbox" value="" id="MustExplain" name="MustExplain" checked={values.MustExplain} onChange={e => {

                    if (hasExplainAlert && e.target.checked) {
                        let modal = Modal.getOrCreateInstance(modalWarningRef.current);
                        modal.show();
                    }
                    handleChange(e);
                }
                } />
                <label className="form-check-label" htmlFor="MustExplain">
                    Activer le mode verbose
                </label>        </div>
            <div ref={modalWarningRef} className="modal" tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Attention</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body alert alert-warning">
                            <p>Ce mode demande beaucoup de place en base de données !!!</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-success" data-bs-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div></>

    }

   return  <><div className="mb-3">
        <label htmlFor="FinderEngineName" className="form-label">Finder Engine</label>
        <select className="form-select" aria-label="Finder engine" id="FinderEngineName" name="FinderEngineName" placeholder="Finder engine" onChange={handleChange} value={values.FinderEngineName}>
           <option value="" hidden>selectionnez</option>
           {personalInfoFinders.map(x => <option key={x}>{x}</option>)}

        </select>
    </div>
    <div className="mb-3">
        <label htmlFor="ScoreMatchageEngineName" className="form-label">Score Matcher Engine</label>
        <select className="form-select" aria-label="Scorer engine" id="ScoreMatchageEngineName" name="ScoreMatchageEngineName" placeholder="Finder engine" onChange={handleChange} value={values.ScoreMatchageEngineName}>
               <option value="" hidden>selectionnez</option>
               {matchageScoreCalculators.map(x => <option key={x}>{x}</option>)}

        </select>
    </div>
    <div className="mb-3">
        <label htmlFor="MaxNumberOfMatchingCandidates" className="form-label">Nombre maximum de résultats matchés</label>
        <input type="number" className={`form-control ${errorCss(errors?.MaxNumberOfMatchingCandidates)}`} id="MaxNumberOfMatchingCandidates" name="MaxNumberOfMatchingCandidates" placeholder="Nombre maximal de résultats matchés" onChange={handleChange} value={values.MaxNumberOfMatchingCandidates} />
        { errors?.MaxNumberOfMatchingCandidates ? (
            <div className="invalid-feedback">{errors?.MaxNumberOfMatchingCandidates}</div>
        ) : (<></>)}
    </div>
    <div className="mb-3">
        <input className="form-check-input me-2" type="checkbox" value="" id="OnlyIntercontrats" name="OnlyIntercontrats" checked={values.OnlyIntercontrats} onChange={handleChange} />
        <label className="form-check-label" htmlFor="OnlyIntercontrats">
            Seulement les intercontrats
           </label>
       </div>
       <div className="mb-3">
           <input className="form-check-input me-2" type="checkbox" value="" id="OnlySalaries" name="OnlySalaries" checked={values.OnlySalaries} onChange={handleChange} />
           <label className="form-check-label" htmlFor="OnlySalaries">
               Seulement les salariés
           </label>
       </div>
       {explain }
   </>
}

export const MatchageConstanteGenerateYup = () => Yup.object().shape({
    MaxNumberOfMatchingCandidates: Yup.number().integer().min(1, 'doit être supérieur à 0').required()
});

export const MatchageConstantesComponent = () => {
    const [constantes, setConstantes] = useState({});
    const [count, setCount] = useState(0);
    const { display } = useToast();

    const formikValidationSchema = MatchageConstanteGenerateYup();

    const formik = useFormik({
        initialValues: constantes,
        validationSchema : formikValidationSchema,
        onSubmit: values => {

            axios.post('/api/MatchageConfiguration', values)
                .then(response => {
                    if (response.status === 200) {
                        display({
                            titre: 'Constantes de matchage mise à jour',
                            text: "Les constantes de matchages vienne d'être mise à jours",
                            severity: 'success'
                        });

                        setCount(count + 1);
                    }
                    else {
                        display({
                            titre: 'Constantes de matchage non mise à jour',
                            text: "Impossible de mettre à jour les constantes de matchage",
                            severity: 'danger'
                        });
                    }
                })


        },
        enableReinitialize: true
    });

    useEffect(() => {
        axios.get("/api/MatchageConfiguration")
            .then(response => {
                if (response.data) {
                    setConstantes(response.data);
                }
            })
    }, [count]);

    return <div>
        <div className="alert alert-info">
        Voici la page de configuration des alertes de matchages, à chaque run le matchage est lancé sur le run avec ces options
        </div>
        <form onSubmit={formik.handleSubmit}>
            <MatchageConstanteFormComponent values={formik.values} handleChange={formik.handleChange} errors={formik.errors} hasExplainAlert={true} hasExplain={ true } />
    <button type="submit" className="btn btn-success" >Valider</button>
    </form></div>
}







